/**
 * interview-slots/availability API: capacity/booked/remaining are already scoped to
 * interview vs mock by the server. Use this for dropdown option labels (not "Unlimited").
 */
export function formatInterviewSlotAvailabilitySuffix(s) {
  const booked = Number(s.booked ?? 0);
  const cap = Number(s.capacity ?? 0);
  const rem = Number(s.remaining ?? Math.max(0, cap - booked));
  if (cap <= 0) return '';
  return `${booked}/${cap} booked · ${rem} free`;
}

export function canBypassInterviewSlotCapacity(user) {
  return ['super_admin', 'admin', 'manager'].includes(String(user?.role || '').toLowerCase());
}
